<template>
  <section class="section" id="about">
    <br>
    <br>
    <div class="container">
      <img :class="[{'b-english': $i18n.locale === 'en'}, 'b-title']" :src="require(`../assets/titles/${$i18n.locale}/about.jpg`)" alt="Über uns">
      <b-divider></b-divider>
      <br>
      <p>{{$t('company.1')}}</p>
      <p>{{$t('company.2')}}</p>
      <br>
      <br>
      <div class="columns">
        <div class="column box b-company">
          <strong>{{$t('company.us.title')}}</strong>
          <br>
          <div class="content">
            <ul>
              <li>
                <fa class="has-text-orange" icon="check"></fa>
                {{$t('company.us.1')}}
              </li>
              <li>
                <fa class="has-text-orange" icon="check"></fa>
                <a href="/GM2099.pdf"> {{$t('company.us.2')}}</a>
              </li>
              <li>
                <fa class="has-text-orange" icon="check"></fa>
                {{$t('company.us.3')}}
              </li>
              <li>
                <fa class="has-text-orange" icon="check"></fa>
                {{$t('company.us.4')}}
              </li>
              <li>
                <fa class="has-text-orange" icon="check"></fa>
                {{$t('company.us.5')}}
              </li>
            </ul>
          </div>
        </div>
        <div class="column box b-datacenter">
          <strong>{{$t('company.center.title')}}</strong>
          <br>
          <div class="content">
            <ul>
              <li>
                <fa class="has-text-orange" icon="check"></fa>
                {{$t('company.center.1')}}
              </li>
              <li>
                <fa class="has-text-orange" icon="check"></fa>
                {{$t('company.center.2')}}
              </li>
              <li>
                <fa class="has-text-orange" icon="check"></fa>
                {{$t('company.center.3')}}
              </li>
              <li>
                <fa class="has-text-orange" icon="check"></fa>
                {{$t('company.center.4')}}
              </li>
              <li>
                <fa class="has-text-orange" icon="check"></fa>
                {{$t('company.center.5')}}
              </li>
            </ul>
          </div>
        </div>
     </div>
    </div>
  </section>
</template>

<script>
import BDivider from '@/components/BDivider.vue';

export default {
  name: 'BAbout',
  components: {
    BDivider,
  },
}
</script>

<style lang="scss" scoped>
  @import "../styles/variables";

  .container {
    padding-right: .75em;
    padding-left: .75em;
    p {
      text-align: center;
    }
  }

  ul {
    list-style: none !important;
    margin: 0 !important;
  }

  .b-title {
    margin-bottom: .4em;
    width: 150px;
  }

  .b-english {
    margin-bottom: .4em;
    width: 100px;
  }

  .b-datacenter {
    margin-bottom: 1.5em;
    margin-left: .5em;
    padding: 2em;
  }

  .b-company {
    margin-right: .5em;
    padding: 2em;
  }

  .network {
    img {
      max-height: 500px;
    }
  }
</style>
